import service from '@/api/service/service';
import qs from "qs";

// 机构详情
export function getOrganizationInfo(params = {}) {
  return service({
    url: '/api/organization/organization_info.json',
    method: 'get',
    params,
  })
}

// 机构中培训班列表
export function getTraningList(params = {}) {
  return service({
    url: '/api/organization/organization_class.json',
    method: 'get',
    params,
  })
}

// 获取培训班详情
export function getClassDetail(params = {}) {
  return service({
    url: '/api/organization/class_train_info.json',
    method: 'get',
    params
  })
}

// 获取培训班中小组的学员列表信息
export function getStuList(params = {}) {
  return service({
    url: '/api/organization/class_group_student.json',
    method: 'get',
    params
  })
}

// 编辑学员资料
export function editStu(data = {}) {
  return service({
    url: '/api/user/student_edit.json',
    method: 'post',
    data: qs.stringify(data),
  })
}

// 创建培训班
export function createTrainClass(data = {}) {
  return service({
    url: '/api/organization/class_train_add.json',
    method: 'post',
    data: qs.stringify(data),
  })
}

// 获取创建培训班中的讲师列表 - 十一人制
export function getLecturers(params = {}) {
  return service({
    url: '/api/organization/create_train_teacher.json',
    method: 'get',
    params
  })
}

// 获取创建培训班中的 守门员教练 讲师列表 - 十一人制
export function getLecturesForGoalkeeper(params ={}) {
  return service({
    url: '/api/organization/create_train_teacher_g.json',
    method: 'GET',
    params
  })
}

// 获取创建培训班中的 体能教练 讲师列表 - 十一人制
export function getLecturesForPhysical(params ={}) {
  return service({
    url: '/api/organization/create_train_teacher_physical.json',
    method: 'GET',
    params
  })
}

// 获取创建培训班中的讲师列表 - 十一人制
export function getLecturersForFive(params = {}) {
  return service({
    url: '/api/organization/create_train_teacher_five.json',
    method: 'get',
    params
  })
}

// 获取创建培训班中的讲师列表 - 十一人制
export function getFiveClassApplicationPeriod(params = {}) {
  return service({
    url: '/api/theApplication/the_application_periods.json',
    method: 'get',
    params
  })
}


// 获取培训班的分组数据列表
export function getGroupingList(params = {}) {
  return service({
    url: '/api/organization/group_student_back.json',
    method: 'get',
    params
  })
}

// 调整培训班小组顺序
export function groupingStusAjax(data = {}) {
  return service({
    url: '/api/organization/group_student_ajax.json',
    method: 'post',
    data: qs.stringify(data),
  })
}

// 下载学员帐号
export function loadStuAccountAjax(data = {}) {
  return service({
    url: '/api/organization/student_download.json',
    method: 'post',
    data: qs.stringify(data),
  })
}

// 编辑修改培训班
export function editClassInfoAjax(data = {}) {
  return service({
    url: '/api/organization/class_train_edit.json',
    method: 'post',
    data: qs.stringify(data),
  })
}

// 调整培训班学员名单
export function editStusInfoAjax(data = {}) {
  return service({
    url: '/api/organization/adjust_class_student.json',
    method: 'post',
    data: qs.stringify(data),
  })
}

// 培训班开班通知下载
export function getClassDown(params = {}) {
  return service({
    url: '/api/organization/class_down.json',
    method: 'get',
    params
  })
}
// 新版培训手册下载
export function getClass_manual_down(params = {}) {
  return service({
    url: '/api/organization/class_manual_down.json',
    method: 'get',
    params
  })
}

// 添加编辑培训班时的后台校验
export function testClassData(data = {}) {
  return service({
    url: '/api/organization/verify_class_info.json',
    method: 'post',
    data: qs.stringify(data),
  })
}

// 调整学员名单保存前的后台校验
export function testStusAdjust(data = {}) {
  return service({
    url: '/api/organization/verify_student_list.json',
    method: 'post',
    data: qs.stringify(data),
  })
}

// 创建培训班时的默认联系人
export function classDefaultLinks(params = {}) {
  return service({
    url: '/api/organization/class_link_list.json',
    method: 'get',
    params,
  })
}

// 创建五人制培训班申请默认联系人
export function getFiveClassApplicationConnection(params = {}) {
  return service({
    url: '/api/theApplication/the_application_link_list.json',
    method: 'get',
    params,
  })
}

// 获取需要测评的教师、机构
export function getRatingInfo(params = {}) {
  return service({
    url: '/api/evaluation/evaluation_data_info.json',
    method: 'get',
    params,
  })
}

// 获取机构管理员测评的培训班列表
export function getRatingList(data = {}) {
  return service({
    url: '/api/evaluation/organization_eva_class.json',
    method: 'post',
    data: qs.stringify(data),
  })
}

// 保存机构管理员评价讲师的结果
export function saveOrgEvaluat(data = {}) {
  return service({
    url: '/api/evaluation/organ_evaluation_tea_save.json',
    method: 'post',
    data: qs.stringify(data),
  })
}

// 机构管理员查看测评详情
export function getEvaluations(params = {}) {
  return service({
    url: '/api/evaluation/org_view_eva.json',
    method: 'get',
    params,
  })
}

// 机构管理员下载演示帐号
export function loadStuAccount(params = {}) {
  return service({
    url: '/api/organization/random_value.json',
    method: 'get',
    params,
  })
}

// 机构审核报名人员
export function personnelCheck(data = {}) {
  return service({
    url: '/api/enroll/personnel_check.json',
    method: 'post',
    data: qs.stringify(data),
  })
}

// 机构审核报名人员
export function class_train_periods(params = {}) {
  return service({
    url: '/api/organization/class_train_periods.json',
    method: 'get',
    params
  })
}

// 添加五人制培训班申请报告
export function postFiveClassApplicationData(data) {
  return service({
    url: '/api/theApplication/the_application_add.json',
    method: 'POST',
    data: qs.stringify(data)
  })
}

// 查看五人制培训班申请报告 application_id
export function getFiveClassApplicationData(params) {
  return service({
    url: '/api/theApplication/the_application_info.json',
    method: 'GET',
    params
  })
}

// 编辑五人制培训班申请报告 application_id
export function putFiveClassApplicationData(data) {
  return service({
    url: '/api/theApplication/the_application_edit.json',
    method: 'POST',
    data: qs.stringify(data)
  })
}

// 创建/编辑培训班获取五人制开班申请列表
export function getApplicationListForClass(params) {
  return service({
    url: '/api/theApplication/the_application_list_select.json',
    method: 'GET',
    params
  })
}

// 下载学员服装尺码信息
export function loadStuDressSizeAjax(data = {}) {
  return service({
    url: '/api/organization/student_dress_size_download.json',
    method: 'post',
    data: qs.stringify(data),
  })
}
// 下载学员签到表
export function loadSignSheetAjax(data = {}) {
  return service({
    url: '/api/organization/student_sign_sheet_download.json',
    method: 'post',
    data: qs.stringify(data),
  })
}
// 会员协会提交处罚列表
export function punishPeopleList(params) {
  return service({
    url: '/api/punish/punish_people_list.json',
    method: 'GET',
    params
  })
}
// 会员协会提交处罚
export function addPunishPeople(data = {}) {
  return service({
    url: '/api/punish/add_punish_people.json',
    method: 'post',
    data: qs.stringify(data),
  })
}
// 会员协会提交处罚
export function editPunishPeople(data = {}) {
  return service({
    url: '/api/punish/edit_punish_people.json',
    method: 'post',
    data: qs.stringify(data),
  })
}
// 处罚详情
export function viewPunishInfo(params) {
  return service({
    url: '/api/punish/view_punish_info.json',
    method: 'GET',
    params
  })
}
// 删除处罚申请
export function removePunishPeople(data = {}) {
  return service({
    url: '/api/punish/remove_punish.json',
    method: 'post',
    data: qs.stringify(data),
  })
}
// 下载学员身份证照片信息
export function loadStudentProfileAjax(params) {
  return service({
    url: '/api/organization/student_profile_download.json',
    method: 'GET',
    params
  })
}
